import React from "react";
import { Link } from "react-router-dom";
import { Animated } from "react-animated-css";
import Illustration from "../assets/illustration.png";
import ArrowRight from "../assets/generalicons/arrow-right-yellow.png";

const Error = () => {
  return (
    <React.Fragment>
      <div className="container">
        <Animated animationIn="fadeInUp" isVisible={true}>
          <div className="box">
            <div className="row">
              <div className="col-sm-6">
                <img
                  src={Illustration}
                  alt="error404"
                  className="illustration"
                />
              </div>
              <div className="col-sm-6">
                <div className=" card error-card">
                  <div className="card-body">
                    <h4 className="mb-5">404 Error.</h4>
                    <p className="mb-2">
                      Oops. seems like you are lost xP. Anyway you can go back
                      to Home page
                    </p>
                    Got back to home
                    <Link to="/">
                      <img
                        src={ArrowRight}
                        alt="arrow"
                        height="15px"
                        style={{ paddingLeft: "15px" }}
                        className="arrowstrans"
                      />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Animated>
      </div>
    </React.Fragment>
  );
};

export default Error;
